import L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export default function initMap({ ajaxUrl, templates } = {}) {
    const mapContainer = document.getElementById("map");
    if (!mapContainer) return null;

    console.log("initMap is called");

    const zoomLevel = 14;

    const tiles = L.tileLayer(
        "https://realestate.marketingwebsites.ca/mapLeaflet/tile/positron/{z}/{x}/{y}",
        {
            maxZoom: 18,
            tileSize: 512,
            zoomOffset: -1,
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }
    );

    // Initialize map after DOM is ready
    const map = L.map("map", {
        layers: [tiles],
        center: [45.5019, -73.5674],
        zoom: zoomLevel,
    });

    const markers = L.markerClusterGroup({
        chunkedLoading: true,
        chunkInterval: 200,
        chunkProgress: function (processed, total, elapsed) {
            const progress = document.getElementById("progress");
            const progressBar = document.getElementById("progress-bar");
            if (elapsed > 1000 && progress && progressBar) {
                progress.style.display = "block";
                progressBar.style.width =
                    Math.round((processed / total) * 100) + "%";
            }
            if (processed === total && progress)
                progress.style.display = "none";
        },
        chunkDelay: 50,
    });

    // Custom marker icon
    const myIcon = L.icon({
        iconUrl: "/wp-content/uploads/2023/01/marker.svg",
        iconSize: [24, 24],
        iconAnchor: [12, 24],
        popupAnchor: [0, -50],
    });

    // Marker map to track existing markers
    const markerMap = new Map();

    // Function to populate map with markers
    map.populateMap = async function (params) {
        try {
            const url = `${ajaxUrl}?action=search_listings&${params}&status=EV&limit=1000`;
            const response = await fetch(url);
            const data = await response.json();
            const results = data?.results || [];
            const mlsSet = new Set(results.map((p) => p.property.mls_no));

            console.log(url);
            console.log("map.populateMap is called");

            // Remove old markers
            for (let [mls, marker] of markerMap) {
                if (!mlsSet.has(mls)) {
                    markers.removeLayer(marker);
                    markerMap.delete(mls);
                }
            }

            // Add new markers
            results.forEach((property) => {
                const mls = property.property.mls_no;
                if (!markerMap.has(mls)) {
                    const marker = L.marker(
                        [
                            parseFloat(property.property.latitude),
                            parseFloat(property.property.longitude),
                        ],
                        { icon: myIcon }
                    );

                    marker.on("click", () => {
                        if (!marker.getPopup()) {
                            marker
                                .bindPopup(templates.popupTemplate(property))
                                .openPopup();
                        }
                    });

                    markers.addLayer(marker);
                    markerMap.set(mls, marker);
                }
            });

            map.addLayer(markers);
        } catch (error) {
            console.error("Error fetching map data:", error);
        }
    };

    console.log(new URLSearchParams(window.location.search));
    map.populateMap(new URLSearchParams(window.location.search));

    // Fit map bounds from input or URL
    map.fitBoundsFromParams = function (boundsInput) {
        if (!boundsInput) return;
        const boundsStr = boundsInput.value || "";
        if (!boundsStr) return;
        const [north, east, south, west] = boundsStr.split(",").map(parseFloat);
        const sw = L.latLng(south, west);
        const ne = L.latLng(north, east);
        map.fitBounds(L.latLngBounds(sw, ne));
    };

    // Handle moveend event to update form search
    map.on("moveend", function () {
        const boundsInput = document.querySelector('[name="bounds"]');
        if (!boundsInput) return;
        boundsInput.value = [
            map.getBounds().getNorth(),
            map.getBounds().getEast(),
            map.getBounds().getSouth(),
            map.getBounds().getWest(),
        ].join();

        const form = document.querySelector("#advanced--search");
        if (form && !new URLSearchParams(window.location.search).has("q")) {
            form.dataset.byMove = "true";
            form.dispatchEvent(
                new Event("submit", { bubbles: true, cancelable: true })
            );
        }
    });

    return map;
}
